import { createContext, useContext } from "react";

import { classNames } from "@helpers/css";

type OverallCoreValuesAssessmentQuestionDescriptionContextType = {
  averageScoreOfIndividualCoreValuesBasedQuestions?: string;
  scale?: number;
};

export const OverallCoreValuesAssessmentQuestionDescriptionContext =
  createContext<OverallCoreValuesAssessmentQuestionDescriptionContextType>({});

const OverallCoreValuesAssessmentQuestionDescription = ({
  className,
}: {
  className?: string;
}) => {
  const context = useContext(
    OverallCoreValuesAssessmentQuestionDescriptionContext
  );

  return context.averageScoreOfIndividualCoreValuesBasedQuestions ? (
    <div className={classNames("mt-1 text-sm text-gray-400", className)}>
      Average score based on above Core Values assessments:{" "}
      {context.averageScoreOfIndividualCoreValuesBasedQuestions}/
      {context.scale ?? "3"}
    </div>
  ) : null;
};

export default OverallCoreValuesAssessmentQuestionDescription;
